import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { isAuthPath } from "@/lib/auth-routes";
import { Loader2 } from "lucide-react";

export function PublicRoute() {
  const { user, isLoading, passwordRecoveryActive, signupInProgress } =
    useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Password reset link establishes a session before the user sets a new password.
  // Stay on the auth page until they submit the recovery form (PublicRoute would
  // otherwise redirect them to the dashboard immediately).
  const hash = typeof window !== "undefined" ? window.location.hash : "";
  const recoveryInUrl =
    hash.includes("type=recovery") ||
    hash.includes("type%3Drecovery") ||
    decodeURIComponent(hash).includes("type=recovery");

  const allowAuthDuringRecovery =
    isAuthPath(location.pathname) && (passwordRecoveryActive || recoveryInUrl);

  // `supabase.auth.signUp` emits SIGNED_IN before the signup handler has created
  // the profile row (and the workspace + feature flags its trigger seeds).
  // Redirecting on the session alone mounts AppLayout → WorkspaceProvider too
  // early: it reads zero memberships, settles on "no workspace", and the
  // dashboard renders with an empty sidebar and skeletons until a manual reload.
  if (user && !allowAuthDuringRecovery && !signupInProgress) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
